/**
 * WebSocket Vuex Module
 * 全ActionCableチャネルの接続状態を一元管理する
 */
export default {
  namespaced: true,

  state: {
    channels: {},
  },

  getters: {
    isAnyDisconnected: state => {
      const entries = Object.values(state.channels)
      if (entries.length === 0) return false

      // 一度接続済み（lastConnectedAtがnullでない）かつ切断中のチャネルがある場合のみtrue
      return entries.some(ch => ch.lastConnectedAt !== null && !ch.connected)
    },

    disconnectedChannels: state => {
      return Object.entries(state.channels)
        .filter(([, ch]) => ch.lastConnectedAt !== null && !ch.connected)
        .map(([name]) => name)
    },
  },

  mutations: {
    REGISTER_CHANNEL(state, channelName) {
      if (!state.channels[channelName]) {
        state.channels = {
          ...state.channels,
          [channelName]: {
            connected: false,
            lastConnectedAt: null,
            lastDisconnectedAt: null,
          },
        }
      }
    },

    SET_CHANNEL_CONNECTED(state, { channel, connected }) {
      if (!state.channels[channel]) return

      const now = new Date().toISOString()
      state.channels = {
        ...state.channels,
        [channel]: {
          ...state.channels[channel],
          connected,
          ...(connected ? { lastConnectedAt: now } : { lastDisconnectedAt: now }),
        },
      }
    },
  },

  actions: {
    channelConnected({ commit, state }, channelName) {
      const ch = state.channels[channelName]
      const isReconnect = ch && ch.lastDisconnectedAt !== null

      commit('SET_CHANNEL_CONNECTED', { channel: channelName, connected: true })

      if (isReconnect) {
        console.log(`[WebSocket] ${channelName} reconnected at ${new Date().toISOString()}`)
      } else {
        console.log(`[WebSocket] ${channelName} connected at ${new Date().toISOString()}`)
      }
    },

    channelDisconnected({ commit }, channelName) {
      commit('SET_CHANNEL_CONNECTED', { channel: channelName, connected: false })
      console.log(`[WebSocket] ${channelName} disconnected at ${new Date().toISOString()}`)
    },
  },
}
